export default __webpack_public_path__ + "static/media/medium.bba5832f.woff2";